// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tV5A","select":"styles_select__1mAd7"};